import {
  OPERATION_TYPES_DATA_LOADING,
  OPERATION_TYPES_DATA_FAILED,
  OPERATION_TYPES_DATA_SUCCESS,
} from "../types"

const initialState = {
  operationTypes: [],
  loading: false,
  error: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case OPERATION_TYPES_DATA_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        operationTypes: [],
      }
    case OPERATION_TYPES_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        operationTypes: [],
      }
    case OPERATION_TYPES_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        operationTypes: action.payload.OperationType,
      }
    default:
      return state
  }
}
